const accountTypes = [
  {
    country: 'Mexico',
    types: [
      {
        id: 'mx_mxn_b',
        name: 'Business',
        transfersTypes: ['internal', 'spei'],
        batchesTypes: ['internal'],
      },
      {
        id: 'mx_mxn_m',
        name: 'Merchant',
        transfersTypes: ['internal', 'spei'],
        batchesTypes: ['internal'],
      },
      // {
      //   id: "mx_mxn_gw",
      //   name: "Gateway",
      // }
    ],
  },
  {
    country: 'Chile',
    types: [
      {
        id: 'cl_clp_b',
        name: 'Business',
        transfersTypes: ['internal', 'external'],
        batchesTypes: ['internal'],
      },
      {
        id: 'cl_clp_m',
        name: 'Merchant',
        transfersTypes: ['internal'],
        batchesTypes: ['internal'],
      },
    ],
  },
];

const reduceAccount = (result, { id, transfersTypes = [], batchesTypes = [] }) => ({
  ...result,
  [id]: { transfersTypes, batchesTypes },
});
const accountActions = accountTypes.map(({ types }) => types).flat().reduce(reduceAccount, {});

const AccountTypeRepo = {
  all: () => accountTypes,
  batchActions: (accountTypeId) => {
    const { [accountTypeId]: { batchesTypes: actions = ['internal'] } = {} } = accountActions;
    return actions;
  },
  transactionActions: (accountTypeId) => {
    const { [accountTypeId]: { transfersTypes: actions = ['internal'] } = {} } = accountActions;
    return actions;
  },
};

export default AccountTypeRepo;
